import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconComponent } from '@/design-system/atoms/icon/icon.component';

@Component({
  selector: 'app-topbar-title',
  imports: [IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './topbar-title.component.scss',
  templateUrl: './topbar-title.component.html',
})
export class TopbarTitleComponent {
  icon = input.required<string>();
  label = input.required<string>();
}
